// Import model
import { DataviewObjectTaskResponse } from '../models/DataviewObjectTaskResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterObjectTaskRequest } from '../models/FilterObjectTaskRequest';
import { ObjectTask } from '../models/ObjectTask';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterObjectTaskRequestSerializer } from './FilterObjectTaskRequestSerializer';
import { ObjectTaskSerializer } from './ObjectTaskSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewObjectTaskResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewObjectTaskResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewObjectTaskResponse instance
   */
  static deserialize(json: string): DataviewObjectTaskResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewObjectTaskResponse instance
   */
  static fromObject(obj: any): DataviewObjectTaskResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewObjectTaskResponse');
    }


    const instance: DataviewObjectTaskResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ObjectTaskSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterObjectTaskRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewObjectTaskResponse instances
   */
  static deserializeArray(json: string): DataviewObjectTaskResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewObjectTaskResponse instance to a JSON string
   */
  static serialize(instance: DataviewObjectTaskResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewObjectTaskResponse instance to a plain object
   */
  static toObject(instance: DataviewObjectTaskResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ObjectTaskSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterObjectTaskRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewObjectTaskResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewObjectTaskResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
